'use strict'
import { useEffect, useContext, useState } from 'react'
// @mui material components
import Card from '@mui/material/Card'
import Icon from '@mui/material/Icon'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import Autocomplete from "@mui/material/Autocomplete";

import { Link as MuiLink, Stack, Grid, FormControl, InputLabel, Select, MenuItem, Tooltip } from '@mui/material'

// Material Dashboard 2 PRO React components
import MDBox from 'components/MDBox'
import MDSnackbar from 'components/MDSnackbar'
import MDButton from 'components/MDButton'
import MDInput from "components/MDInput";


// Material Dashboard 2 PRO React example components
import DashboardLayout from 'components/LayoutContainers/DashboardLayout'
import DashboardNavbar from 'components/Navbars/DashboardNavbar'
import Footer from 'components/Footer'
import DataTable from 'components/Tables/DataTable'
import ReportIcon from '@mui/icons-material/Report';

// zerouno
import authService from 'services/auth.service'
import customerService from 'services/customer.service'
import mainService from 'services/order.service'
import enumerationService from 'services/enumeration.service'
import { useParams, Link, useNavigate, useLocation } from 'react-router-dom'
import ZUTitleForm from 'components/ZeroUno/ZUTitleForm'
import utils from 'utils/utils.js'
import RabbitContext from 'context/rabbit.js'
import { config } from 'variables/Config.js'
import { DateTime } from "luxon";

export default function OrderTableByState({ states, title }) {
  const location = useLocation()
  const [objId, setObjId] = useState(0)
  const [objects, setObjects] = useState([])
  const [filtered, setFiltered] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [filters, setFilters] = useState({
    provincia: "",
    consegna: null
  });
  const [showSnackbar, setShowSnackbar] = useState({
    sh: false,
    msg: '',
    color: 'success'
  })
  const [openConfirm, setOpenConfirm] = useState(false)
  const [openEditDialog, setOpenEditDialog] = useState(false)
  const [editingOrder, setEditingOrder] = useState(null)
  const {
    data: enums,
    isLoading: loadEnum,
    error: errEnums
  } = enumerationService.findByType('orderState')
  const { rabbit } = useContext(RabbitContext)
  const sales = useLocation().pathname.includes('sales')
  // Removed individual state for consegna as it's now in filters object
  const {
      data: consegne,
      isLoading: loadConsegne,
      error: errConsegne,
    } = enumerationService.findByType("consegna");

  useEffect(() => {
    fetchObjects()
  }, [sales, location])
  
  useEffect(() => {
    // Apply filters whenever objects change
    if (objects.length > 0) {
      applyFilters(filters);
    }
  }, [objects]);

  const fetchObjects = () => {
    mainService
      .findByStates(rabbit.companyId, states)
      .then(response => {
        const orders = response.data.filter(s => rabbit.black ? s.code === '50' : s.code !== "50")
        setObjects(orders)
        setFiltered(orders)
      })
      .catch(error => {
        setShowSnackbar({
          sh: true,
          msg: error.response
            ? error.response.data.message
            : 'errore di ricezione dati',
          color: 'error'
        })
      })
  }

  // Delete
  const deleteObject = () => {
    setOpenConfirm(false)
    mainService.remove(objId).then(
      response => {
        setShowSnackbar({
          sh: true,
          msg: 'operazione effettuata con successo',
          color: 'success'
        })
        fetchObjects()
      },
      error => {
        setShowSnackbar({
          sh: true,
          msg: error.response
            ? error.response.data.message
            : 'errore di ricezione dati',
          color: 'error'
        })
      }
    )
  }

  const handleOpenEditDialog = (order) => {
    setEditingOrder(order)
    setOpenEditDialog(true)
  }

  const handleCloseEditDialog = () => {
    setOpenEditDialog(false)
    setEditingOrder(null)
  }

  // Funzione di validazione come in OrderForm.js
  const validateOrder = (order) => {
    // stato aperto 1 data inizio = null
    // stato spedito 2 data inizio = null
    // stato consegnato 3 data inizio !=null
    // stato chiuso 4 data inizio !=null
    // stato annullato 5 fai che cazzo vuoi
    const s = order.stateId;
    const d = order.dateBegin;
    const r = order.dateReturn;
    
    if ((s === '3' || s === '4' || s === 3 || s === 4) && !d) {
      setShowSnackbar({
        sh: true,
        msg: "inserire la data di inizio",
        color: "error",
      });
      return false;
    }
    
    if (!order.sale && (s === '4' || s === 4) && !r) {
      setShowSnackbar({
        sh: true,
        msg: "inserire la data di rientro",
        color: "error",
      });
      return false;
    }
    
    return true;
  };

  const handleSaveEdit = () => {
    if (!editingOrder) return

    // Creiamo una copia dell'ordine per applicare i controlli
    const orderToSave = { ...editingOrder }
    
    // Controlli come in OrderForm.js
    const s = orderToSave.stateId
    const d = orderToSave.dateBegin
    const r = orderToSave.dateReturn
    
    // Se lo stato è 1 o 2 (probabilmente in attesa o in lavorazione) e c'è una data di inizio, la impostiamo a null
    if ((s === '1' || s === '2' || s === 1 || s === 2) && (d || d === '')) {
      orderToSave.dateBegin = null
    }
    
    // Se lo stato non è 4 (probabilmente completato) e c'è una data di ritorno, la impostiamo a null
    if ((s !== '4' && s !== 4) && (r || r === '')) {
      orderToSave.dateReturn = null
    }
    
    // Validazione dell'ordine prima di salvare
    if (!validateOrder(orderToSave)) {
      return;
    }

    mainService.update(orderToSave.id, orderToSave).then(
      response => {
        setShowSnackbar({
          sh: true,
          msg: 'Ordine aggiornato con successo',
          color: 'success'
        })
        handleCloseEditDialog()
        fetchObjects()
      },
      error => {
        setShowSnackbar({
          sh: true,
          msg: error.response
            ? error.response.data.message
            : 'Errore durante l\'aggiornamento dell\'ordine',
          color: 'error'
        })
      }
    )
  }

  const handleFilterChange = (filterName, value) => {
    const newFilters = { ...filters, [filterName]: value };
    setFilters(newFilters);
    applyFilters(newFilters);
  };

  const handleProvincia = (value) => {
    handleFilterChange('provincia', value);
  };

  const handleConsegna = (value) => {
    handleFilterChange('consegna', value);
  };

  const applyFilters = (currentFilters = filters) => {
    const filteredData = objects.filter((s) => {
      const provinceMatch = currentFilters.provincia === "" || s.prov.toLowerCase() === currentFilters.provincia.toLowerCase();
      const consegnaMatch = currentFilters.consegna === null || s.consegnaId === currentFilters.consegna.id;
      return provinceMatch && consegnaMatch;
    });
    setFiltered(filteredData);
  };

  const columns = [
    {
      Header: 'azioni',
      sortable: false,
      filterable: false,
      width: 100,
      accessor: row => (
        <>
          <MDButton
            color='info'
            size='small'
            iconOnly
            component={Link}
            to={`/customers/${row.customer.id}/orders/${row.id}`}
            sx={{ mr: 1 }}
          >
            <Icon>edit</Icon>
          </MDButton>
          <MDButton
            color='info'
            size='small'
            iconOnly
            onClick={() => handleOpenEditDialog(row)}
            sx={{ mr: 1 }}
          >
            <Icon>rate_review</Icon>
          </MDButton>
          {row.customer.mobile && (
            <MDButton
              color="success"
              size="small"
              iconOnly
              component="a"
              href={`https://wa.me/${row.customer.mobile}`}
              target="_blank"
              rel="noopener noreferrer"
              sx={{ mr: 1 }}
            >
              <Icon>phone</Icon>
            </MDButton>)}
            {row.notes && (
              <Tooltip title={row.notes}>
                <ReportIcon color='warning' fontSize="medium"/>
              </Tooltip>)}
        </>
      )
    },
    {
      Header: 'cliente',
      accessor: row =>
        row.customer.surname.toUpperCase() +
        ' ' +
        row.customer.name.toUpperCase()
    },
    {
      Header: "cell",
      accessor: (row) =>
        row.customer.mobile,
    },
    {
      Header: 'data',
      accessor: d => {
        return utils.formatDate(d.dateOrder, 'dd/MM/yyyy')
      }
    },
    {
      Header: 'consegna',
      accessor: d => {
        return d.dateBegin ? utils.formatDate(d.dateBegin, 'dd/MM/yyyy') : '-'
      }
    },
    {
      Header: 'prov.',
      accessor: row => row.prov.toUpperCase()
    },
    {
      Header: 'numero',
      accessor: d => {
        return d.number + ' ' + d.code + (d.extension ? ' [ext]' : '') + (d.substitution ? ' [sost]' : '')
      }
    },
    {
      Header: "stato",
      accessor: (row) =>
        enumerationService.getEnumerationDescription(enums, row.stateId),
    },    
    {
      Header: "scadenza",
      accessor: (d) => {
        if (!d.dateBegin) return "-";

        const endDate = DateTime.fromISO(d.dateBegin).plus({
          days: d.quantity - 1,
        });

        const formattedDate = endDate.toFormat("dd/MM/yyyy");
        const isExpired = endDate < DateTime.now();

        return {
          date: formattedDate,
          isExpired: isExpired,
        };
      },
      Cell: ({ value }) => (
        <span style={{ color: value.isExpired ? "red" : "inherit" }}>
          {value.date}
        </span>
      ),
    },
    {
      Header: 'prenotato',
      accessor: d => {
        return d.datePrenotazioneRitiro ? utils.formatDate(d.datePrenotazioneRitiro, 'dd/MM/yyyy') : '-'
      }
    },

    {
      Header: 'prezzo',
      accessor: d => {
        return d.price
      },
      Cell: ({ value, row }) => utils.formatFloat(value.toFixed(2))
    },
    {
      Header: 'totale',
      accessor: d => {
        return d.totalAmount
      },
      Cell: ({ value, row }) => utils.formatFloat(value.toFixed(2))
    },
    {
      Header: 'da pagare',
      accessor: d => {
        return d.toPay
      },
      Cell: ({ value, row }) => utils.formatFloat(value.toFixed(2))
    },
    {
      Header: "dispositivo",
      accessor: d => {
        return d.product ? d.product.productModel.name : "---"
      },
    },
    {
      Header: 'seriale',
      accessor: d => {
        return d.product
          ? d.product.serial +
          ' | ' +
          d.product.batch +
          ' [' +
          (d.companyId === 1 ? 'T' : 'B') +
          ']'
          : '---'
      }
    },
    ...(authService.isAdmin()
      ? [
        {
          Header: 'agente',
          accessor: d => {
            return d.agent ? d.agent.surname + ' ' + d.agent.name : ''
          }
        },
        {
          Header: 'tecnico',
          accessor: d => {
            return d.technician ? d.technician.surname + ' ' + d.technician.name : ''
          }
        },
        {
          Header: 'utente',
          accessor: d => {
            return d.user ? d.user.username : ''
          }
        }
      ]
      : []),
      {
        Header: "telefono",
        accessor: (row) =>
          row.customer.phone,
      },
      {
        Header: "ddt",
        accessor: (d) => {
          return d.ddtNumber ?? "";
        },
      },
        
  ]

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Card>
          <ZUTitleForm
            bgColor='info'
            title={title}
            icon='list_alt'
          />
          <MDBox p={3} lineHeight={1}>
            <Stack direction="row" justifyContent="space-between">
              {authService.isAdmin() && (
                <MDButton
                  color="success"
                  component={MuiLink}
                  href={
                    config.SERVER_URL +
                    `/orders/download/excel/byState?companyId=${rabbit.companyId}&states=${JSON.stringify(states)}`
                  }
                  target="_blank"
                >
                  esporta in excel
                </MDButton>
              )}
              <MDInput
                label="Provincia"
                value={filters.provincia}
                onChange={(event) => {
                  handleProvincia(event.target.value);
                }}
              />
                              <Autocomplete
                                disablePortal
                                id="consegna"
                                value={filters.consegna || null}
                                options={consegne}
                                sx={{ width: 150 }}
                                renderInput={(params) => (
                                  <MDInput {...params} label="consegna" />
                                )}
                                onChange={(event, value) => {
                                  handleConsegna(value);
                                }}
                                getOptionLabel={(option) => option.description}
                                                                                               
                              />
            </Stack>
          </MDBox>
          <DataTable 
            table={{ columns: columns, rows: filtered }} 
            canSearch 
            pagination={{ 
              variant: "gradient", 
              color: "info",
              currentPage: currentPage,
              onPageChange: (newPage) => setCurrentPage(newPage)
            }}
          />
        </Card>
      </MDBox>
      <Footer />
      <Dialog
        open={openConfirm}
        onClose={() => setOpenConfirm(false)}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
      >
        <DialogTitle id='alert-dialog-title'>
          Confermi eliminazione?
        </DialogTitle>
        <DialogActions>
          <MDButton onClick={() => setOpenConfirm(false)}>Annulla</MDButton>
          <MDButton onClick={deleteObject} autoFocus>
            Conferma
          </MDButton>
        </DialogActions>
      </Dialog>
      <MDSnackbar
        color={showSnackbar.color}
        icon='notifications'
        title='Notifica'
        content={showSnackbar.msg}
        dateTime='adesso'
        open={showSnackbar.sh}
        autoHideDuration={5000}
        close={() => setShowSnackbar({ sh: false, msg: '', color: 'info' })}
      />

      {/* Quick Edit Dialog */}
      <Dialog
        open={openEditDialog}
        onClose={handleCloseEditDialog}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>Modifica rapida ordine</DialogTitle>
        <DialogContent>
          {editingOrder && (
            <Grid container spacing={2} sx={{ mt: 1 }}>
              <Grid item xs={12} sm={6} md={6}>
                <FormControl fullWidth required>
                  <InputLabel>Stato</InputLabel>
                  <Select
                    label="Stato"
                    value={editingOrder.stateId}
                    onChange={(e) => setEditingOrder({...editingOrder, stateId: e.target.value})}
                  >
                    {enums &&
                      enums.map((item) => (
                        <MenuItem key={item.id} value={item.id}>
                          {item.description}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6} md={6}>
                <MDInput
                  fullWidth
                  type="date"
                  label="Data consegna"
                  value={editingOrder.dateBegin ? DateTime.fromISO(editingOrder.dateBegin).toISODate() : ''}
                  onChange={(e) => setEditingOrder({...editingOrder, dateBegin: e.target.value})}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={6}>
                <MDInput
                  fullWidth
                  type="date"
                  label="Data rientro"
                  disabled={!authService.isAdmin()}
                  value={editingOrder.dateReturn ? DateTime.fromISO(editingOrder.dateReturn).toISODate() : ''}
                  onChange={(e) => setEditingOrder({...editingOrder, dateReturn: e.target.value})}
                />
              </Grid>
              <Grid item xs={12}>
                <MDInput
                  fullWidth
                  type="text"
                  label="Note"
                  value={editingOrder.notes || ''}
                  onChange={(e) => setEditingOrder({...editingOrder, notes: e.target.value})}
                  multiline
                  rows={3}
                />
              </Grid>
            </Grid>
          )}
        </DialogContent>
        <DialogActions>
          <MDButton onClick={handleCloseEditDialog}>Annulla</MDButton>
          <MDButton onClick={handleSaveEdit} color="info">
            Salva
          </MDButton>
        </DialogActions>
      </Dialog>
    </DashboardLayout>
  )
}
